export default __webpack_public_path__ + "static/media/hardware-spec-2.b108a673.jpeg";